const buildTimeEnv = {
    APP_NAME: process.env.APP_NAME,
    APP_ENVIRONMENT: process.env.APP_ENVIRONMENT,
    BFF_GRAPHQL_ENDPOINT: process.env.BFF_GRAPHQL_ENDPOINT,
    REST_ENDPOINT: process.env.REST_ENDPOINT,
    UNIFIED_UI_FEATURE_FLAGS_ENDPOINT: process.env.UNIFIED_UI_FEATURE_FLAGS_ENDPOINT,
    TELEMATICS_FEATURE_FLAGS_ENDPOINT: process.env.TELEMATICS_FEATURE_FLAGS_ENDPOINT,
    AMPLITUDE_API_KEY: process.env.AMPLITUDE_API_KEY,
};
const runtimeEnvKeys = [
    'APP_NAME',
    'APP_ENVIRONMENT',
    'BFF_GRAPHQL_ENDPOINT',
    'REST_ENDPOINT',
    'UNIFIED_UI_FEATURE_FLAGS_ENDPOINT',
    'TELEMATICS_FEATURE_FLAGS_ENDPOINT',
    'AMPLITUDE_API_KEY',
];
let runtimeEnvLoadPromise;
const executingAssetUrl = typeof document !== 'undefined' && document.currentScript instanceof HTMLScriptElement
    ? document.currentScript.src
    : undefined;
const webpackPublicPath = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : undefined;
function hasRuntimeEnv() {
    return (typeof window !== 'undefined' &&
        typeof window.serviceManagementEnv === 'object' &&
        window.serviceManagementEnv !== null);
}
function findRuntimeAssetUrl() {
    if (executingAssetUrl) {
        return executingAssetUrl;
    }
    if (webpackPublicPath) {
        return webpackPublicPath;
    }
    const scripts = Array.from(document.scripts);
    return scripts.reverse().find((script) => /(?:^|\/)remoteEntry\.js(?:[?#]|$)/.test(script.src))?.src;
}
export async function ensureRuntimeEnv() {
    if (typeof window === 'undefined') {
        return;
    }
    if (hasRuntimeEnv()) {
        return;
    }
    if (!runtimeEnvLoadPromise) {
        runtimeEnvLoadPromise = new Promise((resolve, reject) => {
            const runtimeAssetUrl = findRuntimeAssetUrl();
            if (!runtimeAssetUrl) {
                reject(new Error('Unable to determine the Service Management remote origin.'));
                return;
            }
            const envUrl = new URL('/env.js', new URL(runtimeAssetUrl, document.baseURI).origin).href;
            const script = document.createElement('script');
            script.src = envUrl;
            script.async = true;
            script.onload = () => {
                if (hasRuntimeEnv()) {
                    resolve();
                }
                else {
                    reject(new Error(`Service Management runtime configuration was not defined by ${envUrl}.`));
                }
            };
            script.onerror = () => {
                reject(new Error(`Unable to load Service Management runtime configuration from ${envUrl}.`));
            };
            document.head.appendChild(script);
        });
    }
    return runtimeEnvLoadPromise;
}
export function initializeWindowRuntimeEnv() {
    if (typeof window === 'undefined') {
        return;
    }
    window.serviceManagementEnv = window.serviceManagementEnv || {};
    for (const key of runtimeEnvKeys) {
        const currentValue = window.serviceManagementEnv[key];
        const buildValue = buildTimeEnv[key];
        if ((currentValue === undefined || currentValue === '') && buildValue !== undefined) {
            window.serviceManagementEnv[key] = buildValue;
        }
    }
}
function resolveWindowEnvValue(key) {
    if (typeof window === 'undefined' || !window.serviceManagementEnv) {
        return undefined;
    }
    const value = window.serviceManagementEnv[key];
    if (typeof value !== 'string') {
        return undefined;
    }
    return value.trim() === '' ? undefined : value;
}
export function getRuntimeEnvValue(key) {
    return resolveWindowEnvValue(key) ?? buildTimeEnv[key];
}
